









import Vue from 'vue'
import { oneOf } from '@/utils/helper'

export default Vue.extend({
  props: {
    name: {
      type: String,
      default: 'check-group'
    },
    id: {
      type: String,
      default: 'check-box'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md',
      validator: oneOf(['sm', 'md', 'lg'])
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange(e: { target: { checked: boolean } }) {
      this.$emit('input', e.target.checked)
    }
  }
})
